import { useState, useEffect, useCallback } from "react";

const sprueche = {
    rassistisch: [
        "Winnetou kam um die Ecke,\nschnupfte und verreckte",
        "Benediktum, Benedaktum\nIn Afrika laufen die Frauen nackt rum,\nBei uns tragen Sie Kleider,\nLeider\nPriiis",
        "Auf rotem Grund ein weisser Strich\nso lächerlich ist Österreich\nPriis🤙",
        "\"Kultuur\" schreit de Buur,\nund schöpft de Jugo vo de Muur!\nPriis",
        "Lieber Rüebli und Tomate\nals Serbe und Kroate.\nPriis",
        "Will eine schwarze was von dir,\nBittest du sie um ein Bier.\nBringt sie dir eins und hat noch Geld,\nWird ein weiteres Bestellt.\nPriis",
        "Simmer glücklich,\nsimmer froh.\nSimmer ned vo Kosovo.\nPriis",
        "Von weitem braust ein Zug heran,\nein Jugo betritt den Bahnübergang.\nDa schliessen sich die Schranken,\nSBB wir danken!\nPriis🤙",
        "Heute saufen, das wird krank,\nOhne Jugos, Gott sei Dank!\nPriis",
        "En Schwiizer ohni Schnupf\nisch wine Tamil ohni Tupf\nPriis🤙",
        "Lieber Barfuess über d Furka,\nals en Fründin mit Burka.\nPriis🤙",
        "Samichlaus du böse maa,\nleg emol din turban aaa.\nScho din Bart esch doch de Wahn,\ngib zue du bisch en TALIBAN!\nPriis🤙",
    ],

    frauenfeindlich: [
        "Lieber eine schwanzgierige\nals eine ganz schwierige.",
        "Fraua sin wia Ladiwaga,\nwenn sie spinnan,\nmuasch vo Hand oblada!",
        "Weiber sei wia Schindla,\nWenn du sie nit gscheid nogelsch\nsei sie beim Nochbor",
        "Das Fötzchen hat es gut,\nbraucht kein mantel und kein hut,\nmuss nicht häckeln und nicht stricken,\nlegt sich hin und lässt sich ficken.\nPriis🤙",
        "Was den Frauen so gefällt\nist ein Mann mit schön viel Geld.\nIch hab kein Geld ich armer Sack,\ndarum bleibt mir nur der Schnupftabak.",
        "Das größte Glück der Frau auf Erden,\nist das Bügeln und gebügelt werden.",
        "Frauen and Macht!\nHauptsach es git znacht!",
        "Nach dem essen soll man rauchen\noder eine Frau gebrauchen,\nhat man beides nicht zur hand,\nbohr ein Loch und fick die Wand\nBries",
        "Falls mer mal im Usgang en chotz grusigi Frau gseht\nund schnäll en Schnupf wäg dem Schock brucht.\nPriis🤙",
        "Siehst du deine Freundin im Sumpfe winken\nwink zurück und lass sie sinken!\nPriis🤙",
        "In der Augenbläue,\nliegt die Frauentreue.\nWillst du eine treue Frau,\nschlag ihr beide Augen blau!\nPriis🤙",
        "Hüte dich vor Frauen,\ndenn die Dümsten sind die Schlauen!!!\nPriis🤙",
        "gsehsch ä frau im triebsand winkä\nwink zrug und lo sie sinkä\nPriis🤙",
        "Siest du eine Frau im Sumpfe winken,\nso wirf ein Stein und lass sie sinken.\nHast du keinen Stein zur Hand,\nso wirf doch gleich die ganze Wand.\nPriis🤙",
        "mi vater isch Zimmerma und zimmerma bi ig\nmi vater hoblet bälke und fraue hoble ig\nmi vater isch metzger und metzger bi ig\nmi vater stächet saue und fraue stäche ig\nPriis🤙",
        "Lieber e Rechti Frau\nals Frauerecht\nPriis🤙",
        "Lieber es Muetermal,\naus dini Mueter mal\nPriis🤙",
        "Hast du eine hässliche alte\nso führ sie an ne Gletscherspalte\nfällt sie nicht von selbst hinein\nso musst du ihr behilflich sein\nPriis🤙",
        "Dini Fründin isch wie Coop:\nFür mich und dich\nPriis🤙",
    ],

    homophob: [
        "Der Schwule lässt die Arbeit ruhn\nund freut sich auf der After nun.",
        "Ein Schwuler spring von Ast zu Ast\nbis der Ast ins Arschloch passt\nPriis",
        "Wie heißt ein schwuler Vogel?\nGayer\nPriis",
        "Lieber klenne Titten\nwia an Schwuala ficken",
        "Ein Vöglein hüpft von Ast zu Ast,\nbis ein Ast ins Arschloch passt\nPriis🤙",
        "Schneewittchen hat nen geilen Po,\nSupertitten sowiso.\nTäglich hat sie wilden Sex,\nmit den Zwergen 1-6,\nnur der schwule 7.Zwerg,\nfickt Hänsel hinterm Berg!!!!!\nPriis🤙",
        "Biene Maya hatte grosse Titten,\nDoch der Willy blieb cool.\nBiene Maya wollte ihn ficken,\nDoch der Willy der war schwul.\nDrum wurde Maya eine Lesbe\nUnd vogelte ganz schnell 'ne Wespe\nPriis🤙",
        "Eiger Mönch und all die grossen\nwollten einst die Jungfrau stossen\nda sprach der Mönch Ich würd mich fügen,\nmir würd auch das Finsterarschloch gnügen.\nPriis🤙",
    ],

    pervers: [
        "Auf jedem Schiff, das dampft & segelt,\ngibt's einen, der die Putzfrau vögelt.\nIst das Schiff auch noch so klein -\neiner muss die Putzfrau sein.\nPriis!",
        "Scheiß auf Sex scheiß auf Liebe,\nhoch lebe das Handgetriebe!",
        "Lieber a Tennisposter\nwia da Penis im Toaster",
        "Passt der Tanga zum BH,\ndann war der Plan scho vorher da.\nIst der Sack auch noch rasiert -\nWusst auch er was heut passiert.\nPries",
        "Liaber a Stegagländer\nwia an Glegaheitsständer",
        "Liaber Schamlippen küssen\nals Schlamm schippen müssen!",
        "Willsch koa Kind,\nspritz an Grind\nPriis",
        "Ene mene prülimah,\nwer vogla will,\nsöll dHand uf ha!",
        "Sufa, Schnupfa, Randaliera,\nScheiße an die Wände schmiera,\nHura vogla, Z'Geld verprassa,\nUschi a di Muschi fassa,\nam Pfarrer ins Gebetsbuach schießa,\nJungs und Mädels des isch des wahre Läba\ndrum lasst üs a paar Hüfle heba.\nPriiis",
        "Liaber an Wixer im Gsicht,\nals Wixe im arsch",
        "Liabr oane nudla\nals zwei spaghetti!!!\nPriss",
        "Als Fred Feuerstein den Grill erfand,\nhat er sich den Schwanz verbrannt,\ndie Wilma musste rasen\nund ihn wieder heile blasen.",
        "Lieber die Zwetschke gefingert,\nals die Finger gequetscht.",
        "An Buur ohni Steyr\nisch wia an Bueb ohni Eier\nPriiiss",
        "Jesus sprach zu den Korinther,\nhoor am Arsch gid warm im Winter",
        "Liaber am Sekl schwitza,\naswia om dSchwiiz omsekla.\nPriis!",
        "der König kommt herrein gerumst\nwer hat mit meiner frau gebumst\nmeldet sich ein kleiner dicker\nich bins ich bin der üble ficker\ndie moral von der geschicht\nhalbe eier rollen nicht\nPriis",
        "Es war einmal ein Schmied,\nder hat ein 4-kant Glied.\nDann schlug er es zylindrisch,\nweil Liebe macht erfinderisch",
        "Wenn eine Frau ganz pudelnackt\ndich von hinten an der Nudel packt.\nWenn dir so viel gutes wiederfährt,\ndann ist es des Schnupfes Wert.",
        "Früher war es so geregelt\ndas der graf die gräfin vögelt,\nheute ist es so verzwickt\ndas alles durcheinander fickt",
        "Wer sich Socken strickt aus Mösenhaar,\ndem steht das Rohr das ganze Jahr.\nPris",
        "Doba am Saminabrunna\ntua i all min Zipfl sunna\nkregt der siach an sunnabrand,\nkläpf in ufn brunna rand!",
        "Die Möse ist kein Radiosender,\nsie spielt auch keine Lieder,\nsie ist nur ein Erholungsort\nfür steif gewordene Glieder",
        "Wer 15 Jungfraun defloriert,\nhinterher noch onaniert\nund dann nach einer Hure schreit,\ndem sei dieser Schnupf geweiht.\nPriiis",
        "Amerlüga, Fellagatter...\nOhne vögla würsch ne Vater",
        "Liaber Gschwüstra de älter sind,\nals Eltern de Geschwister sind",
        "Es maust die Maus\nEs bumst der Bär\nEs lebe der Geschlechtsverkehr\nWer 3x täglich onaniert\nDanach eine Jungfrau demoliert\nUnd dann noch nach ner Hure schreit,\nDem sei dieser Schnupf geweiht!",
        "Beim Sex kann es vorkommen,\ndass die Nachkommen zu früh kommen\nund die Eltern mit dem Einkommen\nnicht mehr auskommen und umkommen.\nPriiis",
        "Wenn er hängt,\nkhört er im Grund gno in Mund gno.\nDenn ersch recht,\ngschleckt und innegsteckt.",
        "Wer anderen in die Möse beißt,\nist böse meist.",
        "Liaber locker vom hocker,\nals hektisch übern Ecktisch",
        "Es lebe die Liebe, das Bier und der Suff,\nder uneheliche Beischlaf,\nder Papst und das Puff.",
        "Haaram Votz und Haar ade Buuse.\nWää!! Das würd mich Huere Gruuse.\nPriis🤙",
        "Meister Proper putzt das Klo\nsteckt den Finger in den Po\nsteckt den Finger in den Mund\nSchokolade ist gesund\nPriis🤙",
        "Wenns Niklaus mit dem Esel treibt,\ndas Christkind sich am Schlitten reibt,\nknecht Ruprecht auf Maria pennt,\ndann sind wir mitten im Advent\nPriis🤙",
        "Heute Nacht geliebtes Weib,\nbesteig ich deinen Unterleib\nUnd das nicht um Gottes Willen,\nsondern um deine Löcher zu füllen\nUnd empfange meinen Samen,\nin Gottes Namen, Amen!\nPriis🤙",
        "Zwei Mädchen sassen auf einer Bank\nUnd rieben sich die Muschi blank\nDa sagt die Rechte zu der Linken\nRiech wie meine Hände stinken\nPriis🤙",
        "Die kleine Heide\nsteckt sich bunte kreide in die Scheide,\nes ist zwar nicht gesund,\ndafür machts die muschi bunt...\nPriis🤙",
        "Die Muschi hat zwei böse Lappen,\ndie wollen nur den Penis schnappen,\ndoch der Penis ist ein Wicht\nund spuckt der Muschi ins Gesicht!!!\nPriis🤙",
        "Nutten Ficken Geld verprassen\nWeibern an die Möse fassen\ndem Siegrist in die Eiern beissen\ndem Pfarrer ins Gebetbuch scheissen\nJungs das ist das wahre Leben\ndarauf wollen wir einen heben\nPriis🤙",
        "Hinter Dicken Klostermauern\nvögeln Mönche wie die Bauern\nNur der Abt in seiner Zelle\nreibt sich an der Schelle\ner fluchte und er grollte\nweil es ihm nicht kommen wollte\nDa nahm er die Bibel\nund schlug sie über die Zwibel\nPriis🤙",
        "In einem Walde an einem Teiche,\nlage eine Frau als Leiche.\nAuf ihren Brüsten,\nsich zwei Frösche gelüsten.\nIn ihrem Geschlächtskanal,\nein Arm dicker Aal.\nIn ihrem Arsch Kis,\ndrum\nPriis🤙",
        "Wer eine Jungfrau zarten Grottes mit seinem Samenstrahl beglückt,\nwer die ganze Hurenflotte auf einem Beine stehend fickt,\nwer vögelt bis der Pimmel schwitzt,\ndie scheisse aus dem Arsch raus spritzt,\nwer dann noch nach Befriedigung schreit,\ndem sei dieser Priis geweiht\nPriis🤙",
        "A Fotze ohne Geruch\nis wie a Schnupf ohne Spruch\nPriis🤙",
        "lieber ufem chalte Bode hocke,\nstatt mit chalte Hode bocke!\nPriis🤙",
        "Hörst du im Iglu ein getöse,\nPfupft der Eskimo die Eskimöse.\nwird das getöse zum gewimmer,\nwird das gepfupfe immer schlimmer.\nwird aus dem gewimmer ein schrei,\nists mit der Pfupferei vorbei!\nPriis🤙",
        "Dä Pingu bürstet Pinga dure\nsie lot en mache ohni z'murre.\nDä Papa Moll naglet d'Mamma Moll\nDä spitz Globi fickt Globine\nJetzt rödled alli duränand\nund hebet zum schnupfe eri Hand.\nPriis🤙",
        "Draussen vom Walde komm ich her,\nseht mein Sack ist schwer,\nein Jahr lang hatte ich Samenstau\nheut wird gevögelt wie die Sau.\nPriis🤙",
        "Nirä, Herz und Lungä,\nArschloch, Futz und Zungä\nLäck mer doch am Sagg!\nEz nämmer no en Schnupftabak!\nPriis🤙",
        "Nid lang schmeichlä\nine mit de Eichlä\nPriis🤙",
        "Mitten in der Villa\nliegt die todgefickte Jlla\nneben ihr der Schurke\nmit der abgefickten Gurke\nPriis🤙",
        "Liengse biige,\na dr Eichle riibe,\ndas tuet die schlecht Luune vertriibe!!\nPriis🤙",
        "Sex und Röschti,\ndas isch z Gröschti.\nUnd wens mues si,\ndenn lömer d Röschti halt la si!!!\nPriis🤙",
        "der seemann holdrian zog mit seinem kahn\nüber den ozean.\nangekommen am anderen lande\npackte ihn die weiberbande,\ngefesselt an zwei stricken\nmusste er sie alle ficken.\nPriis🤙",
        "Denke mir es ist ein schwinger\nMüde bin ich geh zur Ruh,\nmachs mir selber mit dem Finger,\ndenke mir es ist ein Schwinger.\nPriis🤙",
        "Wer Schwänze lutscht und Mösen leckt,\nder weiss wie es bei Mc Donalds schmeckt.\nPriis🤙",
        "Hart ist der Zahn der Bisamratte.\nDoch noch viel härter ist meine Morgenlatte\nPriis🤙",
        "Der Dildo ist der Apparat,\nder der Frau den Mann erspart!\nStellt man ihn auf Stufe 4,\nvögelt er schon wie ein Stier!\nStellt man ihn auf Stufe 20,\nwird die Milch im Busen ranzig!\nPriis🤙",
        "Pinochio holt sich einen runter,\nSchneewittchen wird beim blasen munter,\ndie Teletubies ficken Anal\ndas ist das Nachtprogramm im Kinderkanal.\nPriis🤙",
        "Ficken, Bumsen und Betatschen\nsind die Hobbys der Apatschen\nPriis🤙",
        "Oh Herr im Himmel lass uns beten,\nich würd so gerne Titten kneten\nMuschis kraulen und besamen!\nOh Herr im Himmel ich danke dir Amen!\nPriis🤙",
        "Salomon der Weise spricht,\nJunge Frauen fickt man nicht,\nman lässt sie spriessen und gedeihen\nbis sie nach den Schwänzen schreien!!!!\nPriis🤙",
        "Kanst du in der Nacht nicht Schnupfen,\nso nimm eine Frau\nund versuch sie zu pfupfen\nPriis🤙",
        "hinter dicken Pyramidenmauern\nvögeln die Pharaonen wie die Bauern...\nPriis🤙",
        "Schnipfi Schnapfi Schnösi,\ndr Schwanz de ghört is Mösi,\nSchnipfi Schnapfi Schäsi,\ndr Schnupf dä ghört is Näsi.\nPriis🤙",
        "ri ra runkel\nFrauäfutz isch dunkel\nwiä chönta au anders sie\nes schient jo ger kei sunä dri.\nPriis🤙",
        "Sommerzeit ist Vögelzeit!\nIn der Sonne unterm Baum,\nnasse Frauen wie im Traum!\nFicken, Bumsen wie ein Stier,\nschönen Sommer wünsch ich dir!!!\nPriis🤙",
        "Futzäschlim und Eichalchääs,\ngit di beschti Mayonäs.\nPriis🤙",
        "Schnupftabak und Futzesaft\ngit üs Manne bärechraft!\nPriis🤙",
        "z läbe isch hert aber mine isch herter\nPriis🤙",
        "Hinterem Huus im Schatte,\nvoglet e Muus e Ratte.\nVor em Huus i de Sunne,\nwichst de Buur in Brunne.\nPriis🤙",
        "Die Jungfernhaut ist die Haut dies weghaut\nwenn die Vorhaut zu fest reinhaut.\nDa kann es vorkommen,\ndass die Nachkommen zu früh kommen\nund wir mit dem Einkommen nicht auskommen.\nPriis🤙",
        "Früher war es so geregelt,\ndass der Chef die Sekretärin fögelt.\nHeute ist alles so verzwickt,\ndass sogar der Stift sie fickt!\nPriis🤙",
        "Früher trug man Unterhosen aus Fotzenhaar,\nda stand der Schwanz das ganze Jahr\nPriis🤙",
        "Ein Mädchen auf der Weide,\nden Finger in der Scheide.\nDen Schwanz im Mund,\ndas ist gesund\nPriis🤙",
        "Heidi sagt zum Peter:\nSteck ihn rein, dein Viertelmeter!\nDoch Peter die arme Sau,\nhatte einen Samenstau...\nDa platzte Peter der Pimmel\njetzt vögelt er im Himmel!\nPriis🤙",
        "Schnupfe uf de Titte\nisch perfekt zum Figge\nPriis🤙",
        "Spass muss sein sagt Wallenstein\nund schob den sack gleich mit hinein.\nPriis🤙",
        "Atilla der Hurenkönig\nkämpfte wenig,\nfickte viel.\nSchlussendlich starb er nicht im Kampf,\nsondern an einen Hodenkrampf.\nPriis🤙",
        "Früher als Viagra noch teurer war,\nda trug man Socken aus Fotzenhaar.\nWer Socken trug aus Fotzenhaar,\ndem stand der Schwanz ein ganzes Jahr.\nPriis🤙",
        "Wenn der Alpenfirn sich röted\nund der Geissenpeter Geissen flöted,\nwenn der Opa auf dem Heidi liegt\nund Frau Holle ihre Tage kriegt,\nwenn Hänsel nur nach Schwänzen schreit\ndann ist Frühlingszeit\nPriis🤙",
        "Wenn beim ficken der Atem keucht\nund der Pimmel spritzt wie wild\nbis der Sperma aus dem Arschloch quillt\ndann war der Schnupf sicher zu mild\nPriis🤙",
        "Shoppen, Schminken, Kaffee trinken\nSchnell dem neuen Lover winken.\nRumficken, Geld verprasseln\nMännern an die Schwänze fassen.\nMädels, das ist das wahre Leben,\ndarauf lasst uns einen heben!\nPriis🤙",
        "Wenn der Igel reitet auf dem Hasen,\nRotkäppchen will dem Fuchs einen blasen\nund Hoppel wird vom Wolf geknallt.\nHoch lebe unser Märchenwald!\nPriis🤙",
        "Ist die Fotze feucht und nass,\nmacht das Vögeln richtig Spass.\nIst sie voller Watte,\nwar es schade um die Latte!\nPriis🤙",
        "Haschte schnupf in der Blutbahn\nkanschte ficken, wie ein Truthahn\nPriis🤙",
        "In der Nacht in der Nacht,\nwenn der Busenhalter kracht.\nWenn der Schwanz explodiert\nso werden kleine Kinder produziert.\nPriis🤙",
        "Morgens wollte sie ihn spüren,\nmit den Lippen zart berühren,\nzum blasen an den Mund hin führen,\nheiss floss dann in sie hinein,\nja so ein Kaffee der ist fein..\nPriis🤙",
        "Die Haustürglocke an der Wand\nein Mädchenbusen in der Hand\nDas sind 2 Dinge sehr verwandt\ndenn wenn man beides zart berührt\nman oben ganz schnell deutlich spürt\ndas unten einer steht und um Einlass fleht!\nPriis🤙",
        "Es Schnüpfli ohni Sprüchli\nisch wie es Fürzli ohni Grüchli\nPriis🤙",
        "Wenn mögli, de vögli.\nWenn nöd, isch blöd.\nPriis🤙",
        "Mädchen müssen damit leben,\ndass Höschen gern am Kitzler kleben.\nDabei entstehen dann Gerüche,\nwie in einer Bratfischküche.\nPriis🤙",
        "Mit Gotteswille und Vaseline,\nbringsch en au in Beton ine.\nPriis🤙",
        "Ein bisschen Spass muss sein\ndachte Frankenstein\nund schob die Eier auch noch rein!\nPriis🤙",
        "Love Is The Name\nSex Is The Game\nForget The Name\nAnd Play the Game\nPriis🤙",
        "Mädchen, seit nicht traurig.\nEs ist nicht alles Trübsal\nwas man blasen kann.\nPriis🤙",
        "Der Frühling naht mit Brausen,\ndie Frauen werden Stolz.\nIch merks an meinem,\ndenn der ist hart wie Holz.\nPriis🤙",
        "Min Schwanz en halbä Meter lang\nliidet unter Geltigsdrang.\nDrum leggi gern en Mantel ah\nund zeig jedem was i drundär ha.\nPriis🤙",
        "Wer morgens junge Schnecken leckt,\nwer mittags einen blasen lässt,\nwer abends noch die Alte knallt,\nder hat das Leben voll geschnallt!\nPriis🤙",
        "Schaut der Bauer in den Himmel\nHat er einen Schimmel\nAuf seinen Pimmel\nPriis🤙",
        "Frau Meier hät fischli puzt\nhinder dä grosä eichä\ndänn isch ihre eis is füzli grutscht\nez cha sie nümä seiche\nPriis🤙",
        "Bi dä Räuber Hotze-Plotz\nund hab in jeder Fotze Plotz...\nPriis🤙",
        "in de Badwanne stoht dFrau Rotz\nund sWasser stoht ere bes zo de... Chnüü\nPriis🤙",
        "Wenn vor Frost die Fütze glänzen,\nsich Eisrauch bildet an den Schwänzen,\nwenn das Eis im Arschloch knallt\nesch es gopferteli chalt!!!\nPriis🤙",
        "z Appezell im Liichehuus,\nflüged d Fütz zum Fenster uus.\nD Schwänz grad hine dri,\nwell au toti Fütz mönd gfögled sii!\nPriis🤙",
        "Ist die Möse weit und offen,\nkannst du auf einen Quickie hoffen.\nIst die Möse eng und klein,\nlass das ficken lieber sein.\nBist du aber trotzdem fies,\nnimm vor dem ficken einen\nPriis🤙",
        "Rummel dummel fummel\ndMannä händ nur en Stummel\nswär so schön wänner immer wür stah\nwäns dFrauä schön wänd ha.\nPriis🤙",
        "Auf dem Weg nach Havanna,\nliegt die Totgefickte Anna.\nNeben ihr der Schurke,\nmit der rotgefickten Gurke.\nPriis🤙",
        "Futz du hast es schön,\nmusst nicht frieren,\nmusst nicht schwitzen,\nkannst einfach vor dem Arschloch sitzen!\nPriis🤙",
        "Böse Möse hat zwei Lappen,\num den geilen Schwanz zu schnappen.\nDoch der Schwanz der Bösewicht,\nwichst der Möse ins Gesicht!\nPriis🤙",
        "Wer Ärsch fickt und Möse leckt,\nder weiss wie Mc Donalds schmeckt!!\nKraul mein Sack und lutsch mein Ding\nglaub mir das schmeckt wie Burger King\nPriis🤙",
        "Der Hund zu der Katze:\nmachs mir mit der Tatze,\nda sagt die Katze zum Hund:\nnein lieber mit dem Mund!\nPriis🤙",
        "Ein Elefant poppt sich durch die Welt,\nweil ihm das Poppen so gefällt.\nAm liebsten poppt er kleine Spatzen,\nweil die beim Höhepunkt so herrlich platzen.\nPriis🤙",
        "Sprach der Elefant zum Kamel,\nwarum hast du 2 Tittä über der Seel?\nSprach das Kamel zum Bösewicht,\nsagt der mit dem Schwanz im Gesicht.\nPriis🤙",
        "Wenn der Bauer säht das Korn\nund die Mädchen tropfen vorn,\nhaben die Knaben einen Ständer,\ndann wirds Frühling im Kalender\nPriis🤙",
        "Wenn man bedenkt, wie er so hängt,\nso locker und lose, in meiner Hose,\nund wenn man ihn rauszieht, wie er dann aussieht,\nso dick und rund - mein Schlüsselbund.\nPriis🤙",
        "Gerade als er gerade war\nknickte er, was schade war\nPriis🤙",
        "Z'Vättis am Taminabruna\ntuan i mina Zipfel suna.\nHet dr Siach a Sunnabrand,\nchlepf na übara Brunarand!!\nPriis🤙",
        "Fuck is easy, fuck is funny,\nmany people fuck for money.\nBut if you don't think fuck is funny,\nfuck yourself and safe your money!\nPriis🤙",
        "If you have the motivation\nto multiplay the population,\ntake a boy behind the door,\nput him softly on the floor,\ntake away the decoration\nand begin the fabrication\nPriis🤙",
        "Agassi, der geile Hund,\nspritzt der Steffi in den Mund.\nHm, sagt sie, das ist lecker,\nbesser als von Boris Becker.\nPriis🤙",
        "SVP staht für: Suufe, Vögle, Priis!\nSP für die wos nöd chönd!\nPriis🤙",
        "Schnupfe ohni schprüchli\nischs gliche wie schissi ohni grüchli!!\nPriis🤙",
        "Z'Muri im Liichehuus,\ndo schliiched d'Liiche ii ond uus,\nsoggeled enander d'Auge uus\ngruusig, gruusig gseht das uus.\nPriis🤙",
        "Mer Schnopfer send die beschte,\nim vöglä und im festä.\nPriis🤙",
        "Hoch zum Kopf,\ntief zum Ei,\ngepriesen sei die Schnupferei!\nPriis🤙",
        "Kräht der Güggel auf dem Huhn,\nhat das mit Wetter nichts zutun!!\nPriis🤙",
    ],

    militaer: [
        "MIt viel Donner und Getösse,\nrobbt ein Büblein aus Ihrer Möse,\nes schnupft und säuft schon wie ein Tier,\nich weiss, es wird ein Grenadier!!!\nPriis🤙",
        "Dä Kadi und dä Korperal\ntribets oft und gern anal,\ndä Löfti üsän Pauseclown\nisch vo dene zwo dä Sohn,\nab so sache muen i chise\ndromm nemäd mer lieber no ä e.\nPriis🤙",
        "Kameraden für alle Zeit\nGrenadiere wo immer ihr seid\nbleibt Kämpfer und Kameraden für alle Zeit\nSeid stolz und kämpft fürs Vaterland\nGott wird euch führen mit gerechter Hand\nPriis🤙",
        "Liebste, schönste und werteste Schweiz,\ndu bist für jeder man ein Reiz.\nSeen, Berge, und schöne Dörfer,\naber vorallem Granatenwörfer\nPriis🤙",
        "Vor 700 Jahren endstand ein Land,\nheute als die Schweiz bekannt,\nmit dem Sturmgewehr in der Hand\nverteidige ich mein Vaterland!\nPriis🤙",
        "Stolzer treuer Grenadier\nversagten seine kräfte hier,\nsein Wille stark wie eine Buche\nliegt er da unter dem weissen Tuche\nPriis🤙",
        "Abends spät noch auf der Wache\nneben mir da rauscht ein Bache\nerschien im hellen Mondesglanz\nein blondes Weib mit Loorbehrkranz.\nEs säuft und schnupft schon wie ein Tier\nich glaub es wird ein Grenadier!\nPriis🤙",
        "Er sauft, raucht und schnupft wie ein Tier\nIch glaube er ist ein Rettungsgrenadier\nPriis🤙",
        "Liegt ein Grenadier tot im Keller,\nwar für ein mal der Füsel schneller!!!!\nPriis🤙",
        "Küchenchefs das sind wir\nwir scheissen auf die Grenadier.\nPriis🤙",
        "Liegt der Panzergreni tot im Keller,\nwar der Mech Aufklärer wieder schneller!\nPriis🤙",
        "Gott vertrauen einander in die Augen schauen,\ndann den Panzer Grennis eins in die Fresse hauen!\nLiegt der Grenni tod im Keller\nwar der Aufklärer wieder schneller!!\nPriis🤙",
        "Wer Mine suecht, de findet.\nWer drufstoht, verschwindet.\nPriis🤙",
        "Ausser Ehre kennt er nichts,\ner kennt nur seine harte Pflicht,\nklar das Auge, blass die Wangen,\nleise in den Tot gegangen,\nanspruchsloser Grenadier,\nmöge Gott dich schrimen!\nPriis🤙",
        "Mit dem Sturmgewehr in der rechten Hand,\nverteidige ich das Vaterland.\nAuf Rotem Grund ein weisses Kreuz,\nWir Lieben dich du schöne Schweiz!\nPriis🤙",
        "Wenn dnase rinnt und zAug brennt,\nscheisse C-Alarm verpennt.\nPriis🤙",
        "Feuer frei\nalso raus mit dem Blei.\nPriis🤙",
    ],

    suff_und_rausch: [
        "Egal wia dicht du bisch,\nGoethe war dichter.",
        "Auch Wasser wird zum edlen Tropfen,\nwenn man es vermischt\nmit Malz und Hopfen.",
        "Liebe Gott wir danken Dir\nfür Schnupftabak und Dosenbier!\nPriis",
        "Lieber Mond du hast es schwer,\nhast allen Grund zur Klage.\nDu bist nur 12 mal voll im Jahr,\ndoch wir sind es alle Tage",
        "Wer viel Alkohol suft isch Alkoholiker\nund wer viel Spiritus suft\nisch Spiritueller.\nPriis.",
        "Der liebe Gott hat nicht gewollt,\ndass edler Rebensaft verderben sollt.\nDarum hat er uns nicht nur die Reben,\nsondern auch den nötigen Durst gegeben.",
        "Bier macht dick, Alkohol krank,\nmir sind Schnupfer, Gott sei Dank.",
        "Schnupftabak und Alkohol\nsind des Menschen größte Feinde wohl,\ndoch in der Bibel steht geschrieben\ndu sollst auch deine Feinde lieben\nBries",
        "Amerlüga, Felsenau...\nOhne sufa würsch net blau",
        "Die Luft ist trüb,\ndas Wasser rein\nFranz Josef muss versoffen sein!!!\nPriis🤙",
        "Alkohol du böser Geist,\nauch wenn du mich zu Boden reisst.\nIch kotz dich aus, ich leg mich nieder,\nich weiss genau, ich sauf dich wieder.\nPriis🤙",
        "Müde bin ich, geh zur Ruh,\ndecke mein Bierbauch zu!\nHerrgott lass den Katter mein\nmorgen nicht so schrecklich sein!\nBitte gib mir wieder Durst -\nalles andre ist mir Wurst!!\nPriis🤙",
        "Alkohol macht d'Birä hohl\nisch mer worst i ha dorst\nguetä nöggser!!!\nPriis🤙",
        "Mein lieber Freund gehab dich wohl\ndein grösster Feind heisst Alkohol.\nDoch in der Bibel steht geschrieben\ndu sollst Deine Feinde lieben.\nWo früher eine Leber war\nist heute eine Minibar\nPriis🤙",
        "Alkohol und Nikotin haut die halbe Menschheit hin.\nOhni Alk und Nikotin gohsch du sowieso dahin.\nDrum drink dis Bier und schnupf di Schnupf,\nwius di sowieso verrupft.\nPriis🤙",
        "Alkohol und Sonnenschein\nSchnupfen und auf Drogen sein,\nwir bleiben unserm Motto treu\ngeil, bekifft und Arbeitsscheu\nPriis🤙",
        "Drogen, Sex und Alkohol\nsind des Menschen Feinde wohl,\ndoch in der Bibel steht geschrieben,\nAuch deine Feinde sollst du lieben!!!\nPriis🤙",
        "Alkohol macht Birne hohl.\nBirne hohl, mehr Platz für Alkohol.\nPriis🤙",
        "Des kleinen Mannes Sonnenschein,\nSchnupfen und besoffen sein\nPriis🤙",
        "wo saufen eine Ehre ist,\nkann kotzen keine Schande sein!\nPriis🤙",
        "wir hocken hier am runden tisch\nund saufen bis er runde ischt...\nPriis🤙",
        "Das Wasser gibt dem Ochsen Kraft\ndem Menschen Bier und Rübensaft.\nDrum danke Gott als guter Christ\ndass du kein Ochs geworden bist\nPriis🤙",
        "Alkohol ischs ganze Leben\ndoch ohne Snüff würds\nfür mich auch keins geben!!!\nPriis🤙",
        "wenn meine Finger zärtlich deinen Hals berühren\nund wenn meine Lippen deine feuchte Öffnung spühren\nweiss ich du gehörst ganz mir\nmein geliebtes Flaschenbier!!!!!\nPriis🤙",
        "Als ich dich zum ersten Mal sah,\nals ich dich zum ersten Mal fühlte.\nAls sich unsere Lippen zusammenführten,\nals ich deinen Saft in mir spürte.\nAch wie sehne ich mich nach dir...\nDu geliebte Flasche Bier!\nPriis🤙",
        "Wir leben nicht vom Bier allein,\nes muss auch dein Schnupf bei uns sein.\nWir danken dir das du uns liebst,\nund uns dies beides täglich gibst.\nPriis🤙",
        "Draussen liegt noch etwas Schnee,\nzuwenig gefroren ist der See,\ndass man könnte Schlittschuh laufen,\ndrum muss man Schnupfen und auch saufen.\nPriis🤙",
        "Nach 30 Jahren stirbt ein Pferd,\ndas niemals hat ein Bier geleert!\nDer Mensch trinkt Schnaps trotz kranker Galle\nund überlebt die Viecher alle.\nDamit ist der Beweis erstellt,\ndass Alkohol gesund erhält.\nDrum lasst uns öfters einen heben,\ndamit wir alle länger leben.\nPriis🤙",
        "Suffä Schnupfä rund um d'Uhr\nDas isch Schwiizer Bergkultur!!\nPriis🤙",
        "Suffe schnopfe rond om d Uhr,\ndas esch üsi Schwizer Landkultur.\nPriis🤙",
        "Wodka, Kafi Schnaps und Bier,\nmorn verjagts mor dä grind wider schier.\nPriis🤙",
        "Mir Schnupfet und Suffet und Kiffet eus zue,\nnachher hesch wenigstens rue.\nPriis🤙",
        "Shisha, Alkohol und Räge\ngebed ois de Säge\nPriis🤙",
        "Bier macht dick,\nSchnapps macht chrank,\nduen ä nöd kiffe,\nsondern sniife!\nPriis🤙",
        "Auf die Liebe,\nAuf das Bier,\nJa darauf Priesen wir!\nPriis🤙",
        "Wir schnupfen auf unser Vaterland,\ndas Bier, das Gras\nund auch der feine Traubensaft.\nPriis🤙",
        "Mier sind doch so hüüfig druff\nSegs jetzt snuff oder suff\nPriis🤙",
        "Gotverdammi isch das geil!\nwenn mir es Bierli binis hei,\nisch üs das Bierli nonid gnue\nde frässe mir e Chue derzue.\ndoch jez chunt z Tüpfli ufem i\nmir hei es Büchsli Schnupf derbii.\nPriis🤙",
        "I love Rock n'Roll\nSchnupftabak, Wyber ond Alkohol\nPriis🤙",
        "Ach Mensch bedenke wohl\ndein grösster Feind heisst Schnupftabak und Alkohol\ndoch steht nicht in der Bibel schon geschrieben\nman solle seine Feinde lieben!!!\nPriis🤙",
        "Fällt der Blick ins Glas mal etwas tiefer,\ngeh nicht gleich zum nächsten Priester,\nund beicht ihm alle deine Fehler,\nnimm zuerst das Döschen und mach es leerer!!\nPriis🤙",
        "Trinke viel und spiel dazu\nso hat man vor Weibern Ruh.\nHolst dann das Döschen auch hervor\nso steigt man mit Freud empor.\nPriis🤙",
        "Was früher meine Leber war,\nist heute eine Minibar.\nPriis🤙",
    ],

    sonstige: [
        "Liaber ned ernst gno wöra,\nals vom Ernst gno wöra.",
        "Egal ob Katz, Hund oder Mus\nda McDonalds macht an Burger drus.",
        "Minus uf plus,\nd sichrig isch dus.",
        "Egal ob Kirche oder Puff\ns'Dach isch druf",
        "A gnagelte Schrufa hebt besser\naswia an gschrufata Nagel",
        "Der Schnupf ist unser liebster Freund!\nEr haut uns nieder,\nwir stehen auf und schnupfen wieder!\nPriiiis",
        "Schnupfa isch gsond,\nSchnupfa isch gschied,\nwer ned schnupft dä bringt's ned wit",
        "Es isch verbota anam tota Kojota\nz Hödle verknota.\nPriis",
        "Hohe Berge klare Sicht,\nhauptsach an köriga Dampf im Gsicht.\nPriiis, guat Luft",
        "Slow done.\nTake it easy,\nnimm as Prisli",
        "Schnupfa ohne Spruch\nisch wia schießa ohne Gruch",
        "Isst der Bauer Abends Schinken,\ntut die Sau am nächsten Morgen hinken.\nPriiis",
        "Die Gams springt hoch,\nDie Gams springt weit.\nWieso tut sie das?\nSie hat die Zeit!\nPriis!",
        "Scho mol a Pommes durch an Wald renna gsacha?\nNa?\nEz woasch mol wia schnell dia Sicha sen...\nPris!",
        "Ez gömr an sprung ins habidere,\nviellicht gits schnitzel mit preiselbeere.\nDano no kurz ins Ei Ei,\ndes git a riesen sauerei.\nPriiiiiis",
        "Egal ob Hond, Katz oder Mus -\nMcDonalds macht dr BigMac drus!",
        "Wennd Wurst solang wias Brot isch,\nischs wurst wielang sBrot isch",
        "Hat die Blume einen Knick,\nwar die Biene wohl zu dick.",
        "Beim Flachdach isch as Dach flach!\nPriiiss!",
        "Liaber im Stuahl ischlofa\nals im schlof istuahla",
        "Klebt der Bauer an der Mauer,\nwar der Stier wohl etwas sauer.",
        "Scheiße auf der Friedhofsmauer,\nstört die Andacht und die Trauer",
        "Hand zur Nase, atme ein,\nja das Braune muss da rein.\nZieh es langsam, zieh es fort\nund du siehst einen besseren Ort",
        "Scheiße auf der Kirchturmspitze,\nstinkt bei kälte und bei hitze",
        "Hast du Krümmel in der Spalte,\nist es Scheiße und zwar alte!",
        "Links ein Baum, rechts ein Baum,\nin der Mitte, man glaub es kaum...\nNoch ein Baum\nBries",
        "Nim dir Zeit und nicht das Leben,\nscheiß ins Klo und nicht daneben.",
        "Schneits im Mai,\nist der April vorbei",
        "Kurz und präzis\nBries",
        "Ich bin eine Raupe,\ndu ein Reh.\nIch werd ein Schmetterling,\ndu ein Filet.",
        "Schnupf du holder Saft,\ngib uns Power gib uns Kraft.\nWir schnupfen dich du haust uns nieder,\nwir stehen auf und schnupfen wieder",
        "Hat der Melker kalte Finger,\nwird die Kuh zum Stabhochspringer.\nPriis!",
        "D Geisterfahrer sean sehr entgegendkommend.\nPriis.",
        "Hoch am Himmel fliegt der Geier\nvon unten sieht man nur seine...\nFüße\nBries",
        "Gott sprach es werde Licht,\ndoch Moses fand den Schalter nicht.\nDa sprach der Abel es liegt wohl am Kabel.\nDarauf der Jesus ganz verduzt:\nI glob es hot dir d'Biera putzt!",
        "Liaber Spaghetticode\nwia Spaghetti im Kot.",
        "Gott sprach zu den Hebrähern,\nkauft euch einen Aebi-Mäher,\nde hön dr eppas gschids\nund es konn a no os dr Schwiiz.\nPriis.",
        "Liabr an Sunnabrand\nals an Summer z Brand",
        "Egal wie fett du bist,\nmein Cousin ist Vetter.",
        "An Schnupf ind Noos,\nmacht da Bizeps gross",
        "Liaber zMarual am schnupfa,\nals zMarual und ned am schnupfa!",
        "Jesus hing am Kreuz und schrie,\nich bruch an Price sus bin hi.",
        "Söttisch schaffä aber hesch kei Pfupf,\nde nisch am bestä ä Apricot Schnupf.\nPriis🤙",
        "De Schiri isch es Lumpepack,\njetzt nämmer no en Schupftabak...\nPriis🤙",
        "Hinderem Huus, vorem Huus\nstoht e alti Eiche!\nD'Muetter hät scho immer gseit,\ndet dörf mer anne seiche!\nPriis🤙",
        "Tell sprach zu den Eigenossen,\nwer nicht schnupft der wird erschossen,\nda kahm Gessler mit geschrei\nund verbot die Schnupferei,\njetzt schnupft wider jedermann...\nPriis🤙",
        "Mir Sattler sind die bestä,\nwers nid glaubt chas cho gu teste,\nbim suffä machid mir nid schlapp,\nwas nid tötet hertät ab!\nPriis🤙",
        "Das Laub fällt von den Bäumen,\nein Hund bellt neumen,\njetzt fängt er noch an zu knurren,\nich glaub ich muss woanders durren!!\nPriis🤙",
        "Auf einem Drogenberg lebten einst 3 Zwerge\nder eine Extesi frass\nder andere rauchte Gras\ndoch der 3. hats richtig erkennt\nund sich dem Schnupfen zugewandt.\nPriis🤙",
        "Keine Höhe zu hoch,\nkein Abgang zu steil,\nFallschirmspringen,\ndas finden wir geil\nPriis🤙",
        "Lieber ein Haus im Grünen\nals die Grünen im Haus!\nPriis🤙",
        "Schnupfe, Schnupfe das isch mis Hobby,\nwer nid schnupft, de isch en Globi.\nPriis🤙",
        "Wieder ist ein Tag vollbracht\nund wieder ist nur Misst gemacht.\nLebt wohl, schlaft gut ihr Sorgen,\nleckt mich am Arsch bis Morgen.\nPriis🤙",
        "Kauf deiner Frau ne Rose\nkauft sie dir ne Dose\nspielt sie mit dir Huke Pak\nbrauchst du den Schnupftabak\nPriis🤙",
        "Auf der Alm da steht ne Kuä\ndie macht ihr Arschloch auf und zuä\nund die Moral von der Geschicht\nhalt auch du dein Arschloch dicht\nPriis🤙",
        "En ghörige Maa hed Frau und Chind,\nHaar uf dä Bruscht und ned uf em Grind!\nPriis🤙",
        "Manne we Tanne\nFraue we Pfaue\nIm Winter Lawine\nIm Summer vill Biene\nÄ Mischtstock vor em Huus\nDä chunsch druus\nPriis🤙",
        "schnupfe rund um d'uhr,\ndas isch uesi vereinskultur.\nPriis🤙",
        "Ich sagte es immer,\nich sage es noch,\ndie kleinsten Frauen\nhaben das grösste Selbstvertrauen\nPriis🤙",
        "Wie kommen wir zusammen? Sternförmig.\nWie gehen wir auseinander? Sternhagelvoll\nPriis🤙",
        "Der Kamerad\nWenn einer von uns müde wird,\nder andere für ihn wacht.\nWenn einer von uns fallen sollt,\nder andere steht für zwei,\ndenn jedem Kämpfer gibt ein Gott\nden Kameraden bei.\nPriis🤙",
        "Mer möche en Kreis\nond schnopfe eis\nPriis🤙",
        "Ein Bärner namens Johann Bieri\nass einen Mocken Chäs zum z'Vieri\nes war vom besten Emmentaler\nmit einem grossen, runden Loch\ndrum lebt der Johann Bieri noch\nPriis🤙",
        "Liebi Eidgenosse und Buure,\nzum schisse müesst er abehure,\nIhr chönd aber au blibe staa\nund alles s Hosebei abelaa!\nPriis🤙",
        "Wer rennt so spät durch Feld und Rüben,\nes ist ein Hase er will nach drüben,\nZaun erreicht mit müh und Not,\nStrom war drauf, jetzt ist er TOT!\nPriis🤙",
        "z Wätter isch miiis drum\nPriis🤙",
        "Rumpeldipumpel\nund weg war der Kumpel\nPriis🤙",
        "Der Hirsch springt hoch\nder Hirsch springt weit\ndas macht ja nichts\ner hat ja Zeit\nPriis🤙",
        "Das Schaf ist weiss und braun,\ndaran schuld ist der Elektrozaun,\nund wenn das Schaf dann nur noch rollt,\nwaren es halt doch zuviel Volt.\nPriis🤙",
        "Es isch verbota\nanam tota Kojota\nz Hödle verknota.\nDenn miteme chnötli im hödli\nischs vögle nid mögli!\nPriis🤙",
        "Wer gesoffen hat, der kann nicht mer laufen!!\nDoch wer geschnupft hat, der kann noch saufen!!\nAlso lasst uns schnupfen!!\nPriis🤙",
        "Das erste Mal\nIch legte meinen Kopf nach hinten.\nes war das erste und letzte Mal\ndas ich mir einen Backenzahn ziehen lasse.\nPriis🤙",
        "Du bist sexy,\ndu bist styler,\nich bin Landwirt, das ist geiler!\nPriis🤙",
        "Er wollte was was sie nicht wollte,\njetzt will sie was was er nicht wollte.\nEin Bier drum\nPriis🤙",
        "Heute sind wir hoch geklettert,\nhaben über die anderen gewettert!\nDoch dieser Schnupf kann sehr gut lindern\nmit einem Bier zusammen den Schmerz zu verhindern\nPriis🤙",
        "Eifach wieder mol eis go schnupfe,\ns'gmüetliche Bier as muul lupfe.\nUf d'Lüüt rundume de gfüllt Handrugge hebe,\nsich de Moment nid vermiese loh und eifach lebe.\nIch bin en Schnupfer und keis Frack,\ngah min Wäg mit de e im Sack\nPriis🤙",
        "Nun bilden wir einen Kreis,\ndas wollen wir um jeden Preis.\nGepriesen seist du unser Schnupf,\ndenn alles andere ist ja PFUPF!!\nPRIS\nPriis🤙",
        "en schnupf ghört efach zo jedem Fescht,\nde chlepft di uf mosch nüd is nescht.\nchli tanze ond singä\nmit denä sachä dösch di ganz nacht dörrä bringe.\nPriis🤙",
        "Hesch ke Gäud für Cigarette,\nhesch ke Gäud für Bier,\nhesch aber gäng gnue Gäud im Sack\nfür Schnupftabak\nPriis🤙",
        "Magnet und Gärschtesaft,\nDo steckt unseri Manneskraft.\nPriis🤙",
        "Mir blibä üsäm Motto treu,\nSchnupfe, Sex u Arbeitsscheu.\nPriis🤙",
        "Ich steh allein im Regen hier\nNur mit Mc Cristals und einem Bier\nBevor ich jetzt aber schiebe ein Kriiiiis\nnehm ich doch lieber ein\nPriis🤙",
        "Erschtäns chöi mir nid Räppä\nzwöitäns Räppä mir miis,\ndrum\nPriis🤙",
        "schnopfe gugge zäme spele\nab ond zu is bierglas schelle\nfäschte fiire omesoue\neifach mol of pauke haue\nPriis🤙",
        "Gott erschuf den Pfand,\nAlkohol ist nicht zu brauchen,\ndenn wir wollen auch nicht rauchen,\nwir wollen snuffen wie die Affen,\nauch wenn wir's nicht nach Hause schaffen!\nPriis🤙",
        "zZüri uf em Limmatplatz,\nhets e schwangeri Frau verplatzt.\nGott lob han i no sTram verwütscht\nsusch hetd mr no a dSchnure gschprützt.\nPriis🤙",
        "I am young I am free\nthat's all I wanna be,\nsex and alcohol all day\nI wanna have, for that I pray!\nPriis🤙",
        "Raupen raupen,\nSchlangen schlängeln,\nVögel vögeln\nPriis🤙",
        "One two ä Schnupf for you\nThree four äs Bier hei mir no gäng gno\nFive six mir hei gärn Sex\nSeven eight die Arsch isch so breit\nNine ten gelobt sei Wilhelm Tell\nPriis🤙",
        "Scheiss auf alles,\nScheiss auf jeden,\ngeh da raus und leb dein Leben!\nPriis🤙",
        "Rest in Peace,\nPriis🤙",
        "Ringli Ringli Ringli\ndas sind rundi dingli.\nTrämli Trämli Trämli\ndas reimt sich nämli.\nPriis🤙",
        "Es sassen einst zwei auf einer Bank.\nDer eine roch, der andere stank.\nDa sagte der roch zum stank,\ngeh auf eine andere Bank!\nDa sagte der stank zum roch,\ngeh du doch!!\nPriis🤙",
        "Wer anderen eine Bratwurst brät,\nhat ein Bratwurstbratgerät\nPriis🤙",
        "Sind die Hühner platt wie Teller,\nwar der Traktor wieder schneller.\nPriis🤙",
        "Es git es Säuli\nmitem Name heisst es Päuli.\nEs suecht so schürig sis Mami,\ndoch das isch leider scho Salami.\nPriis🤙",
        "Wenn Glöcklein dröhnen, Engel brüllen,\nmit Radau die Ohren füllen,\nwenn es mir mit lautem Knall,\nFlocken auf die Rübe schneit,\nheissa dann ist Weihnachtszeit!!!\nPriis🤙",
        "Wemmer ken Schnupftabak meh händ,\ndenn klatschemer ganz eifach it Händ.\nDe Gott git euis scho es Dösschen,\nund schnupfen es mit Röhrchen.\nPriis🤙",
        "Auf den Alpenhöhen\nda weht der Föhn\nda ist das Schnupfen wunderschön\nPriis🤙",
        "Wir sitzen hier am Lagerfeuer\nund schnupfen wie die Ungeheuer,\nbeim Migros gehen wir noch vorbei,\nda gibt es Schnupf und allerlei.\nPriis🤙",
        "Du liegst auf meinem Handrücken\ndas tut mein Herz Entzücken.\nDein wunderschöner Duft\nschwebt süsslich durch die Luft.\nIhr wisst alle was wir meinen\nDeshalb nehmen wir noch einen!\nPriis🤙",
        "graue Haare\nblaue Augen\nlangsame Saichen,\ndass sint schlimme Zaichen\nPriis🤙",
        "Wenn ein Nilpferd hämisch grinst\nund alles plötzlich nach Luft ringt\nentwich dem Nilpferd stinkend Gas\nsoll Schnupf geschwind in unsere Nase steigen\nPriis🤙",
        "wienacht isch bald,\nes wiänächtelet im Wald,\ndu gsehsch es härzigs Rehli,\nes versuuft gad imene Seeli\nPriis🤙",
        "Wenn man den Bucheli im Garten findet,\nhat es ihn wohl vom Dach aben gewindet\nPriis🤙",
        "Der kluge Schnupfer weiss,\ndas Rauchen ist ein Scheiss!!!\nPriis🤙",
        "Ob Hund, Katz oder Muis\nmiär machid ä Servala druis!!!\nPriis🤙",
        "Hast du Power lernst du Maurer,\nhast du Grips und Power\nlernst du Strassenbauer\nPriis🤙",
        "Mein Magnet der du bist im Dösschen,\ngeheiligt werde deine Mischung.\nDein Menthol beweist dein Dasein.\nführe uns nicht in Versuchung\neines anderen Tabak,\nsondern erlöse uns von all den Fusel.\nPriis🤙",
        "Alle Nichtschnupfer die ihr seid\nihr besteht doch nur aus Lust und Neid.\nDrum schnupfen wir noch einen\nnen McChrystal's nen ganz feinen\nPriis🤙",
        "Rede nicht zu lang um den heissen Brei,\nist sowieso alles einerlei.\nSchnupfspruch hin, Schnupfspruch her,\nkomm und schnupf noch einen mehr!\nPriis🤙",
        "Sunne, Meer und Strand\nmir schnupfed jetz uf euse Sunnebrand!!\nPriis🤙",
        "Willst du scheissen ohne Kraft,\ndann trinke Ramseier Apfelsaft.\nPriis🤙",
        "Wenn dr Sanitär is Röhrli pisst\nund dr Stromer Schiessdräck misst.\nWenn dr Moler dWand versaut\nund dr Murer aus schiäf baut,\nde gahts am Architekt ganz mies...\ndrum\nPriis🤙",
        "Schwimmt ein Hund im Zürichsee\nhält er sein Schwänzchen in die Höh.\nPriis🤙",
        "Teigwaren heissen Teigwaren,\nweil sie aus Teig waren.\nPriis🤙",
        "Egal ob Sunnä oder Rägä\nmit Schnupftabak wird dr Tag zum sägä.\nPriis🤙",
        "Wir danken unserm Columbianer,\nder uns brachte den Schnupf von den Indianer.\nEr brachte ihn übers Meer,\ndoch jetzt lebt er nicht mehr.\nPriis🤙",
        "Posaune unser die du bist an der Fasnacht,\nDein Sound komme,\nDeine Power geschehe...\nDenn Dein ist die Luft, der Klang, die Musik\nund die Power.\nPriis🤙",
        "Wenn Sunna zoberscht am Himmel stoht\nund langsam untergoht.\nKindli scho im Bettli sind,\nden nemen miar nomol as Schnüpfli\nwell das isch z'beschta Bettmümpfli...\nPriis🤙",
        "Siehst du im Estrich die Frösche leichen,\nist dies gewiss ein Hochwasserzeichen\nPriis🤙",
        "Oh Herrjesus Christ.\nIm obere Gädeli hets kei Mischt.\nIm undere hets kei Gülla.\nI glaub miar müand go nochafülla.\nPriis🤙",
        "Isches ruhig im ganzä Land,\nde nim ä mal dr Schnupf zur Hand.\nMach z Dösli uf ir freie Luft\nund schmöck dä himmlisch, liecht Duft.\nPriis🤙",
        "Steht eine Dose auf dem Tisch,\nhoffe dass es kein Thunfisch ist,\nReibe deine Nase sehr oft daran\nfreue dich, dass dies nur ein X-mas sein kann.\nPriis🤙",
        "Wer schnupfen kann wie Goethe schreiben\ngeniesst stets schöne Chrystal Scheiben.\nPriis🤙",
        "Hüt en Rappe,\nmorn en Rappe,\ngit ä schöni Zipfelchappe!\nPriis🤙",
        "Lieber numme eis Ei im Sack,\ndäfür ä e Schnupftabak\nPriis🤙",
        "Steht das Essen auf dem Tisch,\nund in deinem Arsche drückt ein Schiss,\ndann scheiss nicht in die nächste Vase,\nsondern zieh den Schnupf dir in die Nase!!\nPriis🤙",
        "De Sepp de hets ned eifach gha,\nde muäsch eifach schnupfä laa!\nPriis🤙",
        "Killer sind Killer,\nmiar Schnupfer sind no vil schlimmr.\nMiar sin starch miar sin gail,\nmiar sin Schnupfer mit Style!\nPriis🤙",
        "Schnüpfli nä und Schnüpfli ha,\nbesser cha's eim gar nid gah.\nPriis🤙",
        "Miär sind fit miär sind zwäg,\nso schnupfed miär uf jedem Wäg\nPriis🤙",
        "Schnupfe isch keh Droge\ndarum chaufemer grad e Dose.\nPriis🤙",
        "Den Weisen aus dem Morgenland\nwar der Schnupf nicht unbekannt.\nDer vierte Weise sag ich dir\nschupfte wie ein Rüsseltier.\nDrum wollen wir nun kräftig schnupfen\nund zwei grosse Häuflein lupfen!!\nPriis🤙",
        "jesus sprach zu den Korintern,\nhoor am Buch get wam im Wenter.\ndies sagte Moses auch\nden auch er hat Haar am Bauch.\nmin Bat get au im Somme wam!!!\nPriis🤙",
        "Jetzt isch EM in Pole und de Ukraine,\ndrum zieh mer üs jetzt äs Schnüpfli ine!\nPriis🤙",
        "Der Schiri pfeift der Ball ist im Tor\nund wir alle Schnupfen zusammen im Chor.\nPriis🤙",
        "Mofa fahrä da isch s'Bescht,\nund dä Schnupf git üs dä Rescht.\nPriis🤙",
        "Tabak ist ein feines Kraut,\nob mans raucht, schnupft oder kaut!\nPriis🤙",
        "Wenn ein Inder ein Inder tötet\ndann ist es indertat eine Inder Tat\nPriis🤙",
        "Im Migros gids aus zum halbe Pris,\nau dr Ries drum\nPriis🤙",
        "A de Finger bruni Chlumpe,\nGit's bim Schnüze ohni Lumpe\nPriis🤙",
        "Ohni Fliis\nKei Priis\nPriis🤙",
        "Abend wars,\ndas Licht schien bleich\nich drehte Runden um den Teich.\nDa flog ich hin o jeminee\nHab die Schwanenscheisse nicht gesehn.\nPriis🤙",
        "Hans flog durch di Lüfte\nlandete auf seiner Hüfte...\nspickte in den Himmel\nund landete zum Glück NICHT auf dem Pimmel\nPriis🤙",
        "Schnupfe Schnupfe das isch gsund\nund derfür gits ou ä Grund.\nHesch dnasä mau verstopft\nchasch Schnupfe so das alues usetropft.\nAbem Schnupfe isch au no keine gstorbe\nPriis🤙",
        "Uf em Stoos ob Schwyz\nisch es Paradies.\nIm Summer gits det Edelwyss\nund im Winter Schnee und\nPriis🤙",
        "Schnii, Schnaa, Schnupf\ndManne hend kei Pfupf,\nwie chönts au andersch sii\nsii händ üs au ned emmer debii!!\nPriis🤙",
        "Was möched Köch i de Chuchii??\nPriiisotto\nPriis🤙",
        "Im Winter isch de Schnee wiis\nPriis🤙",
        "Churz und klar,\nufä mit derä Waar\nPriis🤙",
        "Ist das Wetter nicht so schön,\nhat der Streber trotzdem Föhn.\nDenn er steckt mit seinem Grind,\ntief im Arsch der Lehrerin.\nPriis🤙",
        "Schnupfhymne des MCCE\nDe bruuni Gnuss in Pulverform,\nja, dä isch im Gschmack enorm.\nZämäha und ufezieh,\njawoll, sou heisst s'Motto hie.\nPriis🤙",
    ],
};

const categories = [
    { id: "rassistisch", label: "rassistisch", emoji: "👨🏿", bg: "#FFE066", color: "#B8860B", blob: "#FFD700" },
    { id: "frauenfeindlich", label: "frauenfeindlich", emoji: "🙅‍♀️", bg: "#FF8FA3", color: "#C0003C", blob: "#FF6B8A" },
    { id: "pervers", label: "pervers", emoji: "🌶️", bg: "#7FE0C8", color: "#0E7B5F", blob: "#5CD4B0" },
    { id: "suff_und_rausch", label: "Suff & Rausch", emoji: "🍺", bg: "#FFB347", color: "#A0522D", blob: "#FF9505" },
    { id: "militaer", label: "militaer", emoji: "🪖", bg: "#B8A9FF", color: "#5B3CC4", blob: "#9B8AFF" },
    { id: "sonstige", label: "sonstige", emoji: "🤙", bg: "#A8E6CF", color: "#2D6A4F", blob: "#74C69D" },
];

export default function SchnupfspruchGenerator() {
  const [activeCategory, setActiveCategory] = useState("sonstige");
  const [currentSpruch, setCurrentSpruch] = useState("");
  const [isAnimating, setIsAnimating] = useState(false);
  const [spruchIndex, setSpruchIndex] = useState(0);
  const [confetti, setConfetti] = useState([]);

  const getRandomSpruch = useCallback(
    (cat) => {
      const pool = sprueche[cat];
      let idx;
      do { idx = Math.floor(Math.random() * pool.length); }
      while (idx === spruchIndex && pool.length > 1);
      setSpruchIndex(idx);
      return pool[idx];
    },
    [spruchIndex]
  );

  useEffect(() => {
    const pool = sprueche["sonstige"];
    setCurrentSpruch(pool[Math.floor(Math.random() * pool.length)]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const spawnConfetti = () => {
    const shapes = ["●", "■", "▲", "♦", "★", "♥"];
    const colors = ["#FFE066", "#FF8FA3", "#B8A9FF", "#7FE0C8", "#8ECAE6", "#FFB347", "#FF6B8A"];
    const c = Array.from({ length: 24 }, (_, i) => ({
      id: Date.now() + i,
      x: Math.random() * 100,
      y: -10 - Math.random() * 20,
      rotate: Math.random() * 360,
      size: 8 + Math.random() * 14,
      color: colors[Math.floor(Math.random() * colors.length)],
      shape: shapes[Math.floor(Math.random() * shapes.length)],
      duration: 1.5 + Math.random() * 1.5,
      delay: Math.random() * 0.4,
      drift: (Math.random() - 0.5) * 120,
      fall: 110 + Math.random() * 40,
    }));
    setConfetti(c);
    setTimeout(() => setConfetti([]), 3500);
  };

  const handleNewSpruch = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    spawnConfetti();
    setTimeout(() => {
      setCurrentSpruch(getRandomSpruch(activeCategory));
      setTimeout(() => setIsAnimating(false), 450);
    }, 250);
  };

  const handleCategoryChange = (catId) => {
    if (catId === activeCategory) return;
    setActiveCategory(catId);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentSpruch(getRandomSpruch(catId));
      setTimeout(() => setIsAnimating(false), 450);
    }, 250);
  };

  const cat = categories.find((c) => c.id === activeCategory);

  return (
    <div style={{ ...s.wrapper, background: `linear-gradient(160deg, #FFFDF5 0%, ${cat.bg}22 50%, ${cat.bg}11 100%)`, transition: "background 0.6s ease" }}>
      <a
        href="https://www.buymeacoffee.com/schnupfspruch"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed", top: 16, right: 16, zIndex: 1000,
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "#FFDD00", color: "#000", border: "2px solid #000",
          borderRadius: 12, padding: "8px 16px",
          fontFamily: "Lato, sans-serif", fontWeight: 700, fontSize: 14,
          textDecoration: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.2)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)"; }}
      >
        🤎 Chauf mir en schnupf
      </a>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,600;0,700;0,800;0,900;1,700&family=Caveat:wght@500;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes popIn {
          0% { opacity: 0; transform: translateY(20px) scale(0.9) rotate(-1deg); }
          60% { transform: translateY(-4px) scale(1.02) rotate(0.5deg); }
          100% { opacity: 1; transform: translateY(0) scale(1) rotate(0deg); }
        }
        @keyframes popOut {
          to { opacity: 0; transform: translateY(-16px) scale(0.95); }
        }
        @keyframes confettiFall {
          0% { transform: translate(0, 0) rotate(0deg); opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translate(var(--drift), var(--fall)) rotate(var(--rot)); opacity: 0; }
        }
        @keyframes floaty {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-10px) rotate(3deg); }
          75% { transform: translateY(6px) rotate(-2deg); }
        }
        @keyframes noseWiggle {
          0%, 100% { transform: rotate(0deg) scale(1); }
          20% { transform: rotate(-12deg) scale(1.15); }
          40% { transform: rotate(10deg) scale(1.1); }
          60% { transform: rotate(-6deg) scale(1.05); }
          80% { transform: rotate(4deg) scale(1.02); }
        }
        @keyframes btnBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-3px); }
        }

        .sticker {
          border: 3px solid transparent;
          padding: 10px 18px;
          border-radius: 20px;
          font-family: 'Nunito', sans-serif;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          white-space: nowrap;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          position: relative;
        }
        .sticker:hover {
          transform: translateY(-3px) rotate(-1deg) scale(1.06);
        }
        .sticker:active {
          transform: scale(0.94) rotate(1deg);
        }
        .sticker.active {
          border-color: rgba(0,0,0,0.08);
          box-shadow: 0 4px 16px rgba(0,0,0,0.1), 0 0 0 2px rgba(255,255,255,0.8) inset;
        }
        .sticker.inactive {
          background: white;
          color: #777;
          border-color: rgba(0,0,0,0.06);
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        .sticker.inactive:hover {
          box-shadow: 0 4px 14px rgba(0,0,0,0.1);
        }

        .big-btn {
          border: none;
          padding: 18px 48px;
          border-radius: 24px;
          font-family: 'Nunito', sans-serif;
          font-size: 18px;
          font-weight: 800;
          cursor: pointer;
          color: white;
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
          animation: btnBounce 2s ease-in-out infinite;
        }
        .big-btn:hover {
          transform: translateY(-4px) scale(1.05) rotate(-1deg);
          filter: brightness(1.05);
        }
        .big-btn:active {
          transform: scale(0.95) rotate(1deg);
          animation: none;
        }
      `}</style>

      {/* Floating deco blobs */}
      {[
        { w: 160, h: 160, top: "5%", left: "-3%", dur: "8s", delay: "0s", opacity: 0.18 },
        { w: 120, h: 120, top: "15%", right: "2%", dur: "10s", delay: "-3s", opacity: 0.15 },
        { w: 90, h: 90, bottom: "10%", left: "8%", dur: "12s", delay: "-5s", opacity: 0.12 },
        { w: 70, h: 70, bottom: "20%", right: "5%", dur: "9s", delay: "-2s", opacity: 0.14 },
      ].map((b, i) => (
        <div key={i} style={{
          position: "fixed", pointerEvents: "none",
          width: b.w, height: b.h,
          borderRadius: "50%",
          background: cat.blob,
          opacity: b.opacity,
          filter: "blur(40px)",
          top: b.top, left: b.left, right: b.right, bottom: b.bottom,
          animation: `floaty ${b.dur} ease-in-out ${b.delay} infinite`,
          transition: "background 0.8s ease",
        }} />
      ))}

      {/* Confetti */}
      {confetti.map((c) => (
        <div key={c.id} style={{
          position: "fixed",
          left: `${c.x}%`, top: `${c.y}%`,
          fontSize: c.size,
          color: c.color,
          pointerEvents: "none",
          zIndex: 20,
          "--drift": `${c.drift}px`,
          "--fall": `${c.fall}vh`,
          "--rot": `${c.rotate + 360}deg`,
          animation: `confettiFall ${c.duration}s ease-in ${c.delay}s forwards`,
          opacity: 0,
          animationFillMode: "forwards",
        }}>
          {c.shape}
        </div>
      ))}

      {/* Header */}
      <div style={{ textAlign: "center", zIndex: 2 }}>

        <h1 style={{
          fontFamily: "'Caveat', cursive",
          fontSize: "clamp(42px, 9vw, 68px)",
          fontWeight: 700,
          color: cat.color,
          margin: 0, lineHeight: 1,
          transition: "color 0.5s ease",
        }}>
          Schnupfspruch!
        </h1>
        <p style={{
          fontFamily: "'Nunito', sans-serif",
          fontSize: 14, fontWeight: 700,
          color: "rgba(0,0,0,0.3)",
          marginTop: 4, letterSpacing: "0.04em",
        }}>
          ✨ Dis Schnupf-Orakel ✨
        </p>
      </div>

      {/* Category stickers */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center", maxWidth: 560, zIndex: 2 }}>
        {categories.map((c) => (
          <button
            key={c.id}
            className={`sticker ${activeCategory === c.id ? "active" : "inactive"}`}
            style={activeCategory === c.id ? { background: c.bg, color: c.color } : {}}
            onClick={() => handleCategoryChange(c.id)}
          >
            <span style={{ fontSize: 18 }}>{c.emoji}</span>
            {c.label}
          </button>
        ))}
      </div>

      {/* Spruch Card */}
      <div style={{
        position: "relative", width: "100%", maxWidth: 500,
        minHeight: 200, display: "flex", alignItems: "center",
        justifyContent: "center", zIndex: 2,
      }}>
        <div style={{
          background: "white",
          borderRadius: 28,
          padding: "44px 36px 36px",
          width: "100%", textAlign: "center",
          position: "relative",
          boxShadow: `0 8px 40px ${cat.blob}25, 0 2px 8px rgba(0,0,0,0.04)`,
          border: `3px solid ${cat.bg}`,
          transition: "border-color 0.5s ease, box-shadow 0.5s ease",
          animation: isAnimating
            ? "popOut 0.2s ease forwards"
            : "popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards",
        }}>
          {/* Corner deco */}
          <div style={{
            position: "absolute", top: -14, right: 24,
            fontSize: 28,
            transform: "rotate(12deg)",
            animation: "floaty 3s ease-in-out infinite",
          }}>{cat.emoji}</div>

          <p style={{
            fontFamily: "'Nunito', sans-serif",
            fontSize: "clamp(18px, 3.8vw, 23px)",
            fontWeight: 700,
            fontStyle: "normal",
            color: "#2D2D2D",
            lineHeight: 1.75,
            margin: 0,
          }}>
            {currentSpruch.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                {i < currentSpruch.split("\n").length - 1 && <br />}
              </span>
            ))}
          </p>

          {/* Wavy separator */}
          <svg width="80" height="12" viewBox="0 0 80 12" style={{ margin: "20px auto 12px", display: "block" }}>
            <path
              d="M0 6 Q10 0, 20 6 T40 6 T60 6 T80 6"
              fill="none"
              stroke={cat.bg}
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>

          <span style={{
            fontFamily: "'Caveat', cursive",
            fontSize: 16, fontWeight: 500,
            color: cat.color, opacity: 0.6,
            transition: "color 0.5s ease",
          }}>
            {cat.emoji} {cat.label}
          </span>
        </div>
      </div>

      {/* Button */}
      <button
        className="big-btn"
        onClick={handleNewSpruch}
        style={{
          background: `linear-gradient(135deg, ${cat.blob}, ${cat.color})`,
          boxShadow: `0 6px 24px ${cat.blob}50`,
          zIndex: 2,
          transition: "background 0.5s ease, box-shadow 0.5s ease",
        }}
      >
        🌬️ Meh Schnupf!
      </button>

      {/* Footer */}
      <p style={{
        fontFamily: "'Nunito', sans-serif",
        fontSize: 12, fontWeight: 700,
        color: "rgba(0,0,0,0.15)", zIndex: 2,
        letterSpacing: "0.04em",
      }}>
        Made with 💛 und Schnupftabak
      </p>
    </div>
  );
}

const s = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 20px",
    position: "relative",
    overflow: "hidden",
    gap: 24,
  },
};
